
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";
import { Container, Card, Form, Button } from "react-bootstrap";
import axios from 'axios';
import AdminDashboardLayout from "../../../Components/AdminDashboard/AdminDashboardLayout";
import Loading from 'react-fullscreen-loading';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { toast } from "react-hot-toast";
import MapProduct from "../../../utils/ProductMapper/MapProduct";
import { Can } from "../../../authentication/AuthContext";

export default function ShowUserTrial() {
  const navigate = useNavigate();
  const [screenloader, setScreenloader] = useState(true);
  const [cardData, setCardData] = useState({});

  const [SecurityKey, setSecurityKey] = useState("");
  const [PID, setPID] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [SecurityKeyUpdate, setSecurityKeyUpdate] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [StartDate, setStartDate] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [StartDateUpdate, setStartDateUpdate] = useState(false);

  const [EndDate, setEndDate] = useState("");
  const [EndDateUpdate, setEndDateUpdate] = useState(false);
  const [notifyCustomer, setNotifyCustomer] = useState(true);

  const Param1 = useParams();
  const location = useLocation();
  // eslint-disable-next-line no-unused-vars
  const loc = location.pathname === `/ShowUser/${Param1}` ? true : false;
  const TargetSecurityKey = Param1.TargetSecurityKey;

  const getUserDetail = async () => {
    await axios.get(`${process.env.REACT_APP_API_URL}/admin/trial_licenses/${TargetSecurityKey}`, {
      headers: {
        'Access-Token': localStorage.getItem('accessToken'),
      },
    })
      .then(res => {
        setScreenloader(false);
        if (res.data.status) {
          setCardData(res.data.license);
          setSecurityKey(res.data.license.machine_id);
          setPID(res.data.license.product_id);

          const startdate = DateFormatDispaly(res.data.license.created_at);
          setStartDate(startdate);
          const enddate = DateFormatDispaly(res.data.license.expires_at);
          setEndDate(enddate);
          return;
        }
        else if (res.data.status === false) {
          toast.success('License not Found!');
          return;
        } else {
          toast.error('Something Went Wrong');
          console.log(res.data);
          return;
        }
      })
      .catch(er => {
        setScreenloader(false);
        if (er.response.data?.message) {
          toast.error(er.response.data.message)
        } else {
          console.log(er)
          toast.error("Something Went Wrong")
        }
      })
  };
  useEffect(() => {
    getUserDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const UpdateUserEndDate = async () => {
    const id = TargetSecurityKey;

    await axios.put(`${process.env.REACT_APP_API_URL}/admin/trial_licenses/${id}/change_end_date`, {
      machine_id: cardData.machine_id,
      expires_at: EndDate,
      notify_customer: notifyCustomer,
    }, {
      headers: {
        'Access-Token': localStorage.getItem('accessToken'),
      }
    })
      .then(res => {
        setScreenloader(false);
        console.log(res.data);
        if (res.data.status) {
          if (res.data.email_error) {
            toast.error(res.data.message);
          } else {
            toast.success(res.data.message);
          }
          setTimeout(() => {
            window.location.reload();
          }, notifyCustomer ? 2000 : 1000)
        } else {
          toast.error('Something Went Wrong');
          console.log(res.data);
          return;
        }
      })
      .catch(er => {
        setScreenloader(false);
        if (er.response.data?.message) {
          toast.error(er.response.data.message);
          return;
        } else {
          console.log(er);
          toast.error("Something Went Wrong");
          return;
        }
      })
  };
  const DeleteUser = async () => {
    await axios.post(`${process.env.REACT_APP_API_URL}/admin/trial_licenses/delete`, {
      machine_id: cardData.machine_id,
    }, {
      headers: {
        'Access-Token': localStorage.getItem('accessToken'),
      }
    })
      .then(res => {
        setScreenloader(false);
        // console.log(res.data);
        if (res.data.status) {
          toast.success('License Deleted');
          setTimeout(() => {
            navigate(`/Admin/triallicenses`, { replace: true });
          }, 1000)
        }
        else {
          toast.error('Something Went Wrong');
          console.log(res.data);
          return;
        }
      })
      .catch(er => {
        setScreenloader(false);
        if (er.response.data?.message) {
          toast.error(er.response.data.message)
        } else {
          console.log(er)
          toast.error("Something Went Wrong")
        }
      })
  };
  const DeleteClicked = () => {
    confirmAlert({
      title: 'Confirm to Delete',
      message: 'Are you sure to do this. This Canot be reverted.',
      buttons: [
        {
          label: 'Yes',
          onClick: () => { setScreenloader(true); DeleteUser(); }
        },
        {
          label: 'No',
          // onClick: () => alert('')
        }
      ]
    });
  }
  const Displaydate = (date) => {
    const d1 = new Date(date).toDateString();
    return (d1);
  }
  const DateFormatDispaly = (d) => {
    const t = new Date(d);
    const date = ('0' + t.getDate()).slice(-2);
    const month = ('0' + (t.getMonth() + 1)).slice(-2);
    const year = t.getFullYear();
    return (`${year}-${month}-${date}`);
  };

  const Actions = () => {
    if (StartDateUpdate === false && EndDateUpdate === false && SecurityKeyUpdate === false) {
      return (
        <div className="row">
          <div className='d-flex flex-column flex-sm-row gap-2 mb-3'>
            <Can permission="admin.trial_licenses.delete">
              <Button className="btn admin-btn" onClick={DeleteClicked} variant="danger">Delete</Button>
            </Can>
            <Button style={{ backgroundColor: '#5f75a5ff', color: '#d8d6d6ff', border: 'none'}} onClick={() => { navigate(-1) }} variant="primary">Back</Button>
          </div>
        </div>
      )
    }
    if (EndDateUpdate === true || StartDateUpdate === true || SecurityKeyUpdate === true) {
      return (
        <>
          <div className='d-flex flex-column flex-sm-row gap-2 mb-3'>
            <Can permission="admin.trial_licenses.change_end_date">
              <Button className="btn admin-btn" onClick={UpdateUserEndDate} variant="success">Update</Button>
            </Can>
            <Button onClick={() => { window.location.reload(false) }} variant="danger">Cancel</Button>
          </div>
        </>
      )
    }
  }

  return (
    <div>
      <AdminDashboardLayout />
      <Loading loading={screenloader} background="#fff" loaderColor="#883484" />
      <div className='content-page-bg'>
        <div className='content-page'>
          <div className='content'>
            <h2>Edit Trial License</h2>
            <p className="text-muted">Trial License will be edited for the selected machine.</p>
            <Container fluid className='behind'>
              <Card className='mt-4'>
                <Card.Body>
                  {/* <div className='mb-3 text-left'>
                  <Button onClick={DeleteClicked} variant="danger">Delete This License</Button>
                </div> */}
                  <div className='row my-4'>
                    <div className='col-lg-4 col-md-4 col-6'>
                      <Card.Subtitle className='mb-2 text-muted'>
                        Name
                      </Card.Subtitle>
                      <Card.Title className="text-muted">{cardData.fname} {cardData.lname}</Card.Title>
                    </div>
                  </div>
                  <div className='row my-4'>
                    <div className='col-lg-4 col-md-4 col-12 col-sm-6'>
                      <Card.Subtitle className='mb-2 text-muted'>
                        Email
                      </Card.Subtitle>
                      <Card.Title className="text-muted">{cardData.email}</Card.Title>
                    </div>
                  </div>
                  <div className='row my-4'>
                    <div className='col-lg-4 col-md-4 col-12 col-sm-6'>
                      <Card.Subtitle className='mb-2 text-muted'>
                        Country
                      </Card.Subtitle>
                      <Card.Title className="text-muted">{cardData.country}</Card.Title>
                    </div>
                  </div>
                  <div className='row my-4'>
                    <div className='col-lg-4 col-md-4 col-12 col-sm-6'>
                      <Card.Subtitle className='mb-2 text-muted'>
                        Organization
                      </Card.Subtitle>
                      <Card.Title className="text-muted">{cardData.organization}</Card.Title>
                    </div>
                  </div>
                  <div className='row my-4'>
                    <div className='col-lg-4 col-md-4 col-12 col-sm-6'>
                      <Card.Subtitle className='mb-2 text-muted'>
                        Phone
                      </Card.Subtitle>
                      <Card.Title className="text-muted">{cardData.phone ? cardData.phone : "-"}</Card.Title>
                    </div>
                  </div>
                  <div className='row my-4'>
                    <div className='col-lg-4 col-md-4 col-12 col-sm-6'>
                      <Card.Subtitle className='mb-2 text-muted'>
                        PID
                      </Card.Subtitle>
                      <Card.Title className="text-muted">{MapProduct(cardData.product_id)}</Card.Title>
                    </div>
                  </div>
                  <div className='row my-4'>
                    <div className='col-lg-4 col-md-4 col-12 col-sm-6'>
                      <Card.Subtitle className='mb-2 text-muted'>
                        Security Key
                      </Card.Subtitle>
                      <Card.Title className="text-muted">{cardData.machine_id}</Card.Title>
                    </div>
                  </div>
                  <div className='row my-4'>

                    <div className='col-lg-4 col-md-4 col-6'>
                      <Card.Subtitle className='mb-2 text-muted'>Start Date</Card.Subtitle>
                      <Card.Title className="text-muted">{Displaydate(cardData.created_at)}</Card.Title>
                    </div>

                  </div>
                  <div className='row my-4'>
                    <div className='col-lg-4 col-md-4 col-6'>
                      <Card.Subtitle className='mb-2 text-muted'>Change End Date</Card.Subtitle>
                      <Form.Control
                        type='date'
                        required
                        value={EndDate}
                        onChange={(event) => {
                          setEndDateUpdate(true);
                          setEndDate(event.target.value);
                        }}
                      />
                      <Form.Check
                        className="mt-2"
                        type="checkbox"
                        id="notify-trial-user-end-date"
                        label="Email the trial user about the new end date"
                        checked={notifyCustomer}
                        onChange={(e) => setNotifyCustomer(e.target.checked)}
                      />
                      {/* {EndDateButton()} */}
                    </div>
                  </div>

                  <div className='row my-4'>
                    <div className='col-lg-4 col-md-4 col-6'>
                      <Card.Subtitle className='mb-2 text-muted'>
                        Status
                      </Card.Subtitle>
                      <Card.Title>{cardData.status}</Card.Title>
                    </div>
                  </div>
                  {Actions()}
                </Card.Body>
              </Card>
            </Container>
          </div>
        </div>
      </div>
    </div>
  );
}
